import gsap from 'gsap';

export function trackCursorInAreaAll() {
    const $giantLinkAreas = document.querySelectorAll('.giant-text-link');

    $giantLinkAreas?.forEach($trackingArea => {
        trackCursorInArea($trackingArea, {
            targetSelector: '.giant-text-link__img',
            hitSelector: 'a',
            restOnLeave: false,
        });
    });
}

export function trackCursorInArea($parent, options = {}) {
    if (!$parent) return;

    const settings = {
        targetSelector: '.cursor-tracking-target',
        hitSelector: null,
        activeClass: 'active',
        duration: 0.6,
        ease: 'power3',
        restOnLeave: false,
        maxTilt: 7,
        tiltFullAt: 16,
        ...options,
    };

    const $target = $parent.querySelector(settings.targetSelector);
    if (!$target) return;

    const $hit = settings.hitSelector
        ? ($parent.querySelector(settings.hitSelector) || $parent)
        : $parent;

    if (window.matchMedia('(hover: none), (prefers-reduced-motion: reduce)').matches) {
        return;
    }

    gsap.set($target, {
        xPercent: -50,
        yPercent: -50,
        x: 0,
        y: 0,
        rotation: 0,
        force3D: true,
    });

    const xTo = gsap.quickTo($target, 'x', {
        duration: settings.duration,
        ease: settings.ease,
    });
    const yTo = gsap.quickTo($target, 'y', {
        duration: settings.duration,
        ease: settings.ease,
    });
    const rotationTo = gsap.quickTo($target, 'rotation', {
        duration: 0.35,
        ease: 'power3',
    });

    const tiltFactor = settings.maxTilt / settings.tiltFullAt;
    let prevX = 0;

    function onTick() {
        const x = Number(gsap.getProperty($target, 'x')) || 0;
        const vx = (x - prevX) / gsap.ticker.deltaRatio();
        prevX = x;

        rotationTo(gsap.utils.clamp(-settings.maxTilt, settings.maxTilt, vx * tiltFactor));
    }

    $hit.addEventListener('mouseenter', () => {
        $parent.classList.add(settings.activeClass);
        prevX = Number(gsap.getProperty($target, 'x')) || 0;
        gsap.ticker.remove(onTick);
        gsap.ticker.add(onTick);
    });

    $hit.addEventListener('mousemove', (e) => {
        $parent.classList.add(settings.activeClass);

        const rect = $parent.getBoundingClientRect();
        xTo(e.clientX - (rect.left + rect.width / 2));
        yTo(e.clientY - (rect.top + rect.height / 2));
    });

    $hit.addEventListener('mouseleave', () => {
        $parent.classList.remove(settings.activeClass);
        gsap.ticker.remove(onTick);

        if (settings.restOnLeave) {
            xTo(0);
            yTo(0);
        }

        rotationTo(0);
    });
}
